import { camelizeKeys } from '~/utils/helpers';

export class ResponseTransformer {
    constructor(data) {
        this.data = data;
    }

    transformObjectKey() {
        this.data = camelizeKeys(this.data);
    }

    transformKeyword() {
        this.data.model.keywords.forEach(function (keyword, i, arr) {
            arr[i] = keyword.id;
        });
    }
}
